module.exports = __webpack_public_path__ + "media/assets/images/sunny_sometime_will_snow-aba370613683d31b0b7f73a290eea3b5.png";